import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import CheckIcon from "@mui/icons-material/Check";
import _ from "lodash";
import { useMemo } from "react";
import aderantTheme from "../Theme/AderantTheme";
const getOptionLiStyle = (optionSelected) => css({
    ...(optionSelected
        ? {
            color: aderantTheme.palette.primary.contrastText,
            backgroundColor: `${aderantTheme.palette.primary.main}!important`,
            "&.MuiAutocomplete-option.Mui-focused": {
                backgroundColor: `${aderantTheme.palette.primary.main}!important`
            }
        }
        : {
            color: aderantTheme.palette.text.black,
            backgroundColor: "transparent",
            "&.MuiAutocomplete-option.Mui-focused": {
                backgroundColor: `${aderantTheme.palette.background.hover}`
            }
        }),
    "&:hover": {
        backgroundColor: `${aderantTheme.palette.background.hover}`
    },
    borderRadius: "6px",
    margin: "2px"
});
export function LookupOption(props) {
    const { option, selectedItems, selectable, children, ...other } = props;
    const primaryText = typeof option === "string" ? option : option.primaryText;
    const secondaryText = typeof option === "string" ? "" : option.secondaryText;
    const optionSelected = isOptionSelected(option, selectedItems);
    const optionLiStyle = useMemo(() => getOptionLiStyle(optionSelected), [optionSelected]);
    const onClick = (e) => {
        other.onClick && other.onClick(e);
    };
    return (_jsxs("li", { ...other, css: optionLiStyle, onClick: onClick, children: [selectable && _jsx(CheckIcon, { sx: { visibility: optionSelected ? "visible" : "hidden", marginLeft: "-8px", marginRight: "6px", fontSize: aderantTheme.typography.pxToRem(16) } }), _jsxs("div", { style: { flexDirection: "row", display: "flex" }, children: [_jsxs("div", { style: { flexDirection: "column", display: "flex" }, className: "lookup-option-subText", children: [_jsx("div", { className: "lookup-option-primaryText", children: _jsx("span", { children: primaryText }) }), _jsx("div", { className: "lookup-option-secondaryText", children: _jsx("span", { style: { visibility: secondaryText ? "visible" : "hidden", fontSize: aderantTheme.typography.pxToRem(12) }, children: option.secondaryText }) })] }), children] })] }));
}
function isOptionSelected(option, selectedItems) {
    if (selectedItems) {
        if (Array.isArray(selectedItems)) {
            return _.some(selectedItems, option);
        }
        else {
            return option.id === selectedItems.id;
        }
    }
    return false;
}
LookupOption.defaultProps = {
    selectable: true
};
